import { render, staticRenderFns } from "./TheMentionMenu.vue?vue&type=template&id=43adf001"
import script from "./TheMentionMenu.vue?vue&type=script&lang=js"
export * from "./TheMentionMenu.vue?vue&type=script&lang=js"
import style0 from "./TheMentionMenu.vue?vue&type=style&index=0&id=43adf001&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports